import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors } from 'member-reducer'
import { selectors as membershipsSelector } from 'memberships/reducer'
import { Button } from 'lp-components'
import { AllMembershipsType, MEMBERSHIP_STATUS } from 'types'
import { VideoErrorMessage, VideoPlayer } from 'member-portal/components'
import { makePath, PATH } from 'config'
import { getPrimaryMembership } from 'utils'

const propTypes = {
  allMemberships: AllMembershipsType,
  videoDetails: PropTypes.object,
}

function VideoContent({ allMemberships, videoDetails }) {
  const [errorType, setErrorType] = useState(null)

  const { membershipStatus } = getPrimaryMembership(allMemberships)
  const isDisabled = membershipStatus === MEMBERSHIP_STATUS.EXPIRED

  const {
    is_private: isPrivate,
    video_uid: videoUid,
    categories,
    title,
    image_url: imageUrl,
    long_description: longDescription,
  } = videoDetails

  if (errorType) {
    return (
      <section className="form-block-container">
        <VideoErrorMessage type={errorType} />
      </section>
    )
  }

  return (
    <>
      <div className="top-block" />
      <section className="form-block-container">
        <div className="banner">
          {categories.map((category) => (
            <span key={category}>{category}</span>
          ))}
          <h2 dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        <VideoPlayer
          isDisabled={isDisabled}
          isPrivate={isPrivate}
          imageUrl={imageUrl}
          src={videoUid}
          setErrorType={setErrorType}
        />
        <div
          className="video-body video-description"
          dangerouslySetInnerHTML={{ __html: longDescription }}
        />
        <Button
          className="button-primary-outline"
          onClick={() =>
            window.location.replace(makePath(PATH.SEATOW, PATH.VIDEOS))
          }
        >
          Back to Videos
        </Button>
      </section>
    </>
  )
}

VideoContent.propTypes = propTypes

function mapStateToProps(state) {
  return {
    allMemberships: membershipsSelector.allMemberships(state),
    videoDetails: selectors.videoDetails(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  VideoContent,
)
